export default {
	VoucherBalancingSale: 1,
	UnknownPlaceholder: 2,
	NoSale: 3,
	Generic: 10
};
